import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const HotelManagementCoursePage: React.FC = () => {
  const courseData = {
    title: "Hotel Management & Hospitality",
    shortName: "BHM",
    duration: "3-4 years",
    description: "Comprehensive hospitality management program for hotel and tourism industry",
    overview: "Bachelor of Hotel Management (BHM) is a 3-4 year undergraduate program that provides comprehensive knowledge of hospitality operations, hotel administration, food service management, and tourism. This course combines theoretical learning with extensive practical training in hotel operations, preparing students for managerial roles in hospitality, tourism, and event management industries.",
    eligibility: [
      "10+2 from recognized board",
      "Minimum 50% marks in 12th (45% for SC/ST)",
      "English as compulsory subject",
      "Medical fitness certificate",
      "Good communication and interpersonal skills"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Principles of Hotel Management",
          "Food Production Fundamentals",
          "Food & Beverage Service",
          "Housekeeping Operations",
          "Front Office Operations",
          "Hospitality English"
        ]
      },
      {
        year: 2,
        subjects: [
          "Food & Beverage Management",
          "Accommodation Operations",
          "Hotel Accounting & Finance",
          "Tourism Geography",
          "Hotel Engineering & Maintenance",
          "Hospitality Law"
        ]
      },
      {
        year: 3,
        subjects: [
          "Hotel Marketing & Sales",
          "Human Resource Management",
          "Event Management",
          "Travel & Tourism Management",
          "Hotel Information Systems",
          "Industrial Training"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Hotel Manager",
        "Restaurant Manager",
        "Event Coordinator",
        "Food & Beverage Manager",
        "Front Office Manager",
        "Housekeeping Manager",
        "Tourism Officer",
        "Cruise Ship Manager",
        "Catering Manager",
        "Resort Manager"
      ],
      industries: [
        "Hotels & Resorts",
        "Restaurants & Food Chains",
        "Event Management Companies",
        "Travel & Tourism Agencies",
        "Cruise Lines",
        "Airlines & Airports",
        "Corporate Hospitality",
        "Wedding & Event Planning",
        "Catering Services",
        "Government Tourism Departments"
      ],
      averageSalary: "₹3-7 LPA (Fresher), ₹10-25 LPA (Experienced)",
      topRecruiters: [
        "Taj Hotels, ITC Hotels",
        "Marriott, Hilton, Hyatt",
        "Oberoi Group, Leela Hotels",
        "Radisson, Accor Group",
        "Indian Railways (Catering)",
        "Airlines & Airport Authorities"
      ]
    },

    admissionProcess: [
      "NCHM JEE (National Council for Hotel Management)",
      "State-level entrance examinations",
      "University-specific entrance tests",
      "Merit-based admission on 12th marks",
      "Group discussion and personal interview",
      "Medical fitness verification"
    ],

    topColleges: [
      {
        name: "Institute of Hotel Management",
        location: "Various Cities (IHM)",
        fees: "₹1.5-3 Lakhs",
        ranking: "Government Institutes"
      },
      {
        name: "Welcomgroup Graduate School",
        location: "Manipal",
        fees: "₹4 Lakhs",
        ranking: "Private - Industry Recognized"
      },
      {
        name: "Christ University",
        location: "Bangalore",
        fees: "₹3.5 Lakhs",
        ranking: "University Program"
      },
      {
        name: "Amity University",
        location: "Various Cities",
        fees: "₹4.5 Lakhs",
        ranking: "Private University"
      }
    ],

    hotelManagementColleges: [
      { slNo: 1, code: "411", name: "STATE INSTITUTE OF HMCT", location: "TRICHY" },
      { slNo: 2, code: "602", name: "MGR INSTITUTE OF HMCT", location: "CHENNAI" },
      { slNo: 3, code: "603", name: "SREE BALAJI COLLEGE OF HMCT", location: "TRICHY" },
      { slNo: 4, code: "604", name: "SHEVAROYS COLLEGE OF HMCT", location: "SALEM" },
      { slNo: 5, code: "606", name: "V.J.P.COLLEGE OF HMCT", location: "TRICHY" },
      { slNo: 6, code: "608", name: "EMPEE INSTITUTE OF HMCT", location: "CHENNAI" },
      { slNo: 7, code: "610", name: "DR M G R INTERNATIONAL INSTITUTE OF HMCT", location: "CHENNAI" },
      { slNo: 8, code: "611", name: "JENNEY'S ACADEMEY HMCT", location: "TRICHY" },
      { slNo: 9, code: "612", name: "SRIRAM INSTITUTE OF HMCT", location: "THIRUVALLUR" },
      { slNo: 10, code: "614", name: "ANNAI FATHIMA INSTITUTE OF CATERING ADMINISTRATION", location: "MADURAI" },
      { slNo: 11, code: "615", name: "MAHALAKSHMI COLLEGE OF HMCT", location: "CUDDALORE" },
      { slNo: 12, code: "616", name: "P R INSTITUTE OF HMCT", location: "THANJAVUR" },
      { slNo: 13, code: "618", name: "BHARATH INSTITUTE OF HMCT", location: "THANJAVUR" },
      { slNo: 14, code: "620", name: "N.P.R. INSTITUTE OF HMCT", location: "DINDIGUL" },
      { slNo: 15, code: "", name: "Chennais Amirta IIHM - Chengalpattu Campus", location: "CHENGALPATTU" },
      { slNo: 16, code: "", name: "Annamal Institute of Hotel Management", location: "TAMBARAM" },
      { slNo: 17, code: "", name: "Chennais Amirta International Institute of Hotel Management", location: "CHENNAI" },
      { slNo: 18, code: "", name: "Institute of Hotel Management Catering Technology & Applied Nutrition", location: "CHENNAI" },
      { slNo: 19, code: "", name: "Madras Institute of Hotel Management & Catering Technology", location: "CHENNAI" },
      { slNo: 20, code: "", name: "Annamal Institute of Hotel Management", location: "CHENNAI" },
      { slNo: 21, code: "", name: "The National Institute of Health / Hotel / Humanaties Management - NIHM", location: "CHENNAI" },
      { slNo: 22, code: "", name: "RLT International Institute of Hotel Management", location: "CHENNAI" },
      { slNo: 23, code: "", name: "IHM Chennai", location: "CHENNAI" }
    ],

    skills: [
      "Hotel Operations Management",
      "Customer Service Excellence",
      "Food Safety & Hygiene",
      "Event Planning & Execution",
      "Communication Skills",
      "Leadership & Team Management",
      "Financial Management",
      "Marketing & Sales",
      "Problem Solving",
      "Cultural Sensitivity"
    ],

    futureScope: "Excellent growth prospects with expanding tourism industry, luxury hospitality, experiential travel, and event management creating diverse opportunities in hospitality sector.",

    faqs: [
      {
        question: "What are the physical demands of hotel management career?",
        answer: "Hotel management requires long working hours, standing for extended periods, and physical activity. However, managerial positions involve more planning and supervision rather than operational work."
      },
      {
        question: "Are there international job opportunities?",
        answer: "Yes, hotel management offers excellent international opportunities with global hotel chains, cruise lines, and international hospitality companies actively recruiting skilled professionals."
      },
      {
        question: "Can I start my own hospitality business?",
        answer: "Absolutely! Many graduates start restaurants, catering services, event management companies, boutique hotels, or travel agencies using their hospitality management knowledge."
      },
      {
        question: "What is the importance of industrial training?",
        answer: "Industrial training (usually 6-12 months) is crucial as it provides hands-on experience in hotel operations, guest interaction, and practical application of theoretical knowledge."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0a183d] via-black to-[#1a2746] flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow animate-glow mb-8 text-center">
        {courseData.title}
      </h1>
      <div className="w-full max-w-5xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default HotelManagementCoursePage;
